<template>
  <a-modal
    width="1200px"
    :title="currentItem.name"
    v-model:visible="visible"
    :footer="false">
    <a-tabs>
      <a-tab-pane key="1" tab="任务信息">
        <a-card>
          <div class="paragraph-title">
            基本信息
          </div>
          <div class="info-wrap">
            <div class="info-item">
              <div class="label">任务ID：</div>
              <div class="value">{{ currentItem.id }}</div>
            </div>
            <div class="info-item">
              <div class="label">名称：</div>
              <div class="value">{{ currentItem.name }}</div>
            </div>
            <div class="info-item">
              <div class="label">任务类型：</div>
              <div class="value">{{ getTaskName(currentItem.taskTypeId)}}</div>
            </div>
            <div class="info-item">
              <div class="label">说明：</div>
              <div class="value">{{ currentItem.description?currentItem.description:'--' }}</div>
            </div>
            <div class="info-item">
              <div class="label">发布人：</div>
              <div class="value">{{ getUserName(currentItem.createUserId)}}</div>
            </div>
            <div class="info-item">
              <div class="label">团队：</div>
              <div class="value">{{ getTeamName(currentItem.teamId)}}</div>
            </div>
            <div class="info-item">
              <div class="label">发布时间：</div>
              <div class="value">{{ getDateTime(currentItem.createTime) }}</div>
            </div>
            <div class="info-item">
              <div class="label">要求完成时间：</div>
              <div class="value">{{ getDateTime(currentItem.planFinishTime) }}</div>
            </div>
            <div class="info-item">
              <div class="label">任务总量：</div>
              <div class="value">{{taskNumber}}</div>
            </div>
            <div class="info-item">
              <div class="label">状态：</div>
              <div class="value">{{ currentItem.locking == 'success' ? '任务处理中' : getStateName(currentItem.state) }}</div>
            </div>
            <div class="info-item" v-if="currentItem.state == 'already_deny'">
              <div class="label">拒绝原因：</div>
              <div class="value">{{ currentItem.excuteNote }}</div>
            </div>
          </div>
        </a-card>
        <br>
        <a-card>
          <div class="paragraph-title">
            标注信息
          </div>
          <div class="info-wrap">
            <!--<div class="info-item">
              <div class="label">标注状态：</div>
              <div class="value">{{ currentItem.state }}</div>
            </div>
            <div class="info-item">
              <div class="label">智能标注：</div>
              <div class="value"></div>
            </div>-->
            <div class="info-item">
              <div class="label" style="text-align: left;width: 50px;">状态：</div>
              <div class="value">{{ currentItem.locking == 'success' ? '任务处理中' : getStateName(currentItem.state) }}</div>
            </div>
            <div class="info-item">
              <div class="label">标注子任务数：</div>
              <div class="value">{{ currentItem.taskNumber?currentItem.taskNumber:'--' }}</div>
            </div>
           <!-- <div class="info-item">
              <div class="label">标注公司：</div>
              <div class="value"></div>
            </div>-->
          </div>
          <div class="info-wrap" v-if="subList.length>0">
            <div class="custom-table">
              <div class="table-row tab">
                <p style="width: 100%">子任务名称</p>
                <p style="width: 50%">标注员</p>
                <p style="width: 50%">分配数量</p>
              </div>
              <div class="table-row"
                   v-for="(item, index) in subList || []"
                   :key="index">
                <p style="width: 100%">{{ item.taskName }}</p>
                <p style="width: 50%">{{ item.name }}</p>
                <p style="width: 50%">{{ item.taskNum }}</p>
              </div>
            </div>
            <!--<div class="custom-table">
              <div class="table-row">
                <p style="width: 50%">审核员</p>
                <p style="width: 50%">审核数量</p>
              </div>
              <div class="table-row"
                v-for="(item, index) in currentItem.list2 || []"
                :key="index">
                <p style="width: 50%">{{ item.name }}</p>
                <p style="width: 50%">{{ item.value }}</p>
              </div>
            </div>-->
          </div>
        </a-card>
      </a-tab-pane>
      <a-tab-pane key="2" tab="标注数据" forceRender>
        <PicList ref="picList"
                 :dataset-id="currentItem.datasetId"
                 @settotal="setTotalCount"></PicList>
       <!-- <div class="pic-wrap">
          <div class="pic-item"
            v-for="(item, index) in picList"
            :key="index">
            <img :src="appConfig.baseImgUrl + item.accessSrc"
              alt=""
              @click="openPicDialog">
            <p class="name">{{ item.id }}</p>
          </div>
        </div>
        <a-pagination
          :current="page.pageNum"
          show-quick-jumper
          :pageSize="10"
          :total="total"
          :show-total="total => `共 ${total} 条`"
          @change="getDataItems"
        ></a-pagination>-->
      </a-tab-pane>
    </a-tabs>
<!--    <PicDialog ref="picDialog" :list="picList"></PicDialog>-->
  </a-modal>
</template>
<script>
// import PicDialog from '../PicDialog'
import PicList from '../../DataPreparation/DataSet/PicList'
import { mapState } from 'vuex'
import { getDateTime, getTaskName, getTeamName, getStateName, getUserName } from '@/filters'
import { getDataByPage } from '@/api/dataItem'
import { getMyRelease } from '@/api/task'
import { getDataset } from '@/api/dataSet'
export default {
  props: {
    currentItem: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    // PicDialog,
    PicList
  },
  data () {
    return {
      visible: false,
      page: {
        pageNum: 1,
        pageSize: 10
      },
      // picList: [],
      taskNumber: '--',
      subList: []
    }
  },
  computed: {
    ...mapState(['appConfig'])
  },
  methods: {
    getDateTime,
    getTaskName,
    getTeamName,
    getStateName,
    getUserName,
    open () {
      this.visible = true
      // this.picList = []
      this.subList = []
      this.$nextTick(() => {
        this.$refs.picList.reset()
        // this.getDataItems()
      })
    },
    getDataItems () {
      const addition = this.addition
      const params = Object.fromEntries(addition.split('&').map(str => str.split('=')))
      getDataByPage({ ...this.page, ...params }).then(res => {
        // const data = res.data.map.data
        // this.taskNumber = data.total
        // this.picList = data.rows
      })
    },
    getSubList () {
      getMyRelease({ pageNum: 1, pageSize: 1000, parentId: this.currentItem.id, field: 'name', order: 'asc' }).then(res => {
        const data = res.data.map.data
        if (data.rows.length > 0) {
          for (let i = 0; i < data.rows.length; i++) {
            const obj = {}
            obj.taskName = data.rows[i].name
            obj.id = i
            obj.name = data.rows[i].excuteUserId ? getUserName(data.rows[i].excuteUserId) : '未分配'
            /* if (this.taskNumber % data.rows.length === 0) {
              obj.taskNum = this.taskNumber / data.rows.length
            } else {
              const ys = Math.floor(this.taskNumber / data.rows.length)
              if (i + 1 === data.rows.length) {
                obj.taskNum = this.taskNumber - (data.rows.length - 1) * ys
              } else {
                obj.taskNum = ys
              }
            } */
            getDataset({
              datasetId: data.rows[i].datasetId
            }).then(res => {
              obj.taskNum = res.total
              this.subList.push(obj)
              this.subList.sort(this.order)
            })
          }
        }
      })
    },
    order (a, b) {
      if (a.id < b.id) {
        return -1
      } else if (a.id > b.id) {
        return 1
      } else if (a.id === b.id) {
        return 0
      }
    },
    openPicDialog (url) {
      this.$refs.picDialog.open(url)
    },
    setTotalCount (e) {
      console.log('总量', e)
      this.taskNumber = e
      this.getSubList()
    }
  }
}
</script>
<style lang="less">
  .paragraph-title {
    border-left: 4px solid @theme;
    padding-left: 20px;
  }
  .info-wrap {
    display: flex; flex-wrap: wrap;
    .info-item {
      width: 25%;
      padding: 20px; box-sizing: border-box;
      display: flex;
      div:first-child{
        width: 100px;
        text-align: right;
      }
      div:last-child{
        width: calc(100% - 100px);
      }
    }
    .custom-table {
      width: 50%;
      padding: 20px; box-sizing: border-box;
      .table-row {
        padding:0 10px;
        display: flex;
        height: 50px;
        line-height: 50px;
      }
    }
    .tab{
      border-bottom:1px solid #f0f0f0;
      height: 40px;
      line-height: 40px;
      background: #fafafa;
    }
  }
  .pic-wrap {
    display: flex; flex-wrap: wrap;
    .pic-item {
      padding: 10px; box-sizing: border-box;
      width: 20%; text-align: center;
      img {
        width: 100%; height: 120px;
      }
    }
  }
</style>
